import { reactive } from 'vue';
import { v4 as uuidv4 } from 'uuid';
import { parseContactPhone } from '@/components/salesCrm/phone';

const drafts = new Map();

const emptyDraft = (initialData = {}) => {
  const phones = [...new Set((initialData.contacts || []).map((contact) => parseContactPhone(contact.phone).number || contact.phone?.trim()).filter(Boolean))];
  return reactive({
    requestId: uuidv4(),
    accountPhone: phones.length === 1 ? phones[0] : '',
    accountPhoneCountry: phones.length === 1 ? parseContactPhone(phones[0]).country : '',
    company: {
      commercialName: initialData.company?.commercialName || '',
      legalName: initialData.company?.legalName || '',
      inn: initialData.company?.inn || '',
      ogrn: initialData.company?.ogrn || '',
      kpp: initialData.company?.kpp || '',
      legalAddress: initialData.company?.legalAddress || '',
      signerName: (initialData.contacts || []).length === 1 ? initialData.contacts[0].fullName || '' : '',
      signerTitle: '',
    },
    representative: {
      enabled: false,
      fullName: '',
      powerOfAttorneyDate: '',
      powerOfAttorneyNumber: '',
    },
    bank: { name: '', bik: '', account: '', correspondentAccount: '' },
    points: (initialData.venues?.length ? initialData.venues : [{ name: initialData.company?.commercialName || '', address: '' }]).map((venue) => ({
      venueId: venue.id || undefined,
      name: venue.name || '',
      address: venue.address || '',
      officialPhone: venue.officialPhone || '',
      phoneCountry: parseContactPhone(venue.officialPhone).country,
      officialEmail: venue.officialEmail || '',
      website: venue.website || '',
      posSystem: venue.posSystem || '',
    })),
    tariffId: '',
    billingPeriod: '',
    requestedWaiterSeats: null,
    requestedTrainingSeats: null,
    tipsEnabled: null,
    edoParticipantId: '',
    edoProvider: '',
    recipientEmail: (initialData.contacts || []).filter((contact) => contact.email).length === 1
      ? initialData.contacts.find((contact) => contact.email)?.email || '' : '',
    manualDataAcknowledged: false,
  });
};

export function useContractDraft(clientId, initialData) {
  if (!drafts.has(clientId)) drafts.set(clientId, emptyDraft(initialData));
  return { draft: drafts.get(clientId) };
}

export function clearContractDrafts() {
  drafts.clear();
}

export function clearContractDraft(clientId) {
  drafts.delete(clientId);
}
